// Static demo for the "La mia selezione" tour (the example Sportium slip). No API calls.
const P = (id, home, away, time, market, status, h, a, state, elapsed = null) => ({
  fixture_id: -id, home_team: home, away_team: away, match_date: '2026-10-10', match_time: time,
  market, status, score_home: h, score_away: a, state, elapsed,
});

export const DEMO_SELECTION = {
  notify: true,
  unrecognized: [],
  picks: [
    P(1, 'FSV Mainz 05', 'Bayer Leverkusen', '15:30', 'Over 2.5', 'FT', 3, 1, 'won'),
    P(2, '1899 Hoffenheim', 'Hamburger SV', '15:30', 'Over 2.5', 'FT', 2, 1, 'won'),
    P(3, 'Aston Villa', 'Brentford', '16:00', 'Over 2.5', 'FT', 1, 0, 'lost'),
    P(4, 'Chelsea', 'Bournemouth', '16:00', 'Over 2.5', 'FT', 2, 2, 'won'),
    P(5, 'FC Zurich', 'FC Thun', '18:00', 'Over 2.5', '2H', 1, 1, 'live', 64),
    P(6, 'FC Lugano', 'FC Luzern', '18:00', 'Over 2.5', '2H', 2, 1, 'won', 71),
    P(7, 'RB Leipzig', 'Eintracht Frankfurt', '18:30', 'Multigol 3-6', '1H', 1, 0, 'live', 28),
    P(8, 'Fortuna Sittard', 'Twente', '20:00', 'Over 2.5', 'NS', null, null, 'pending'),
    P(9, '1. FC Nürnberg', 'VfL Wolfsburg', '20:30', 'Over 2.5', 'NS', null, null, 'pending'),
    P(10, 'Monaco', 'Toulouse', '20:45', 'Over 2.5', 'NS', null, null, 'pending'),
    P(11, 'Paris Saint Germain', 'Le Mans', '20:45', 'Multigol 3-6', 'NS', null, null, 'pending'),
    P(12, 'Ajax', 'NEC Nijmegen', '21:00', 'Multigol 3-6', 'NS', null, null, 'pending'),
  ],
};

export const DEMO_IMAGE = '/tutorial/demo_my_selection.webp';
